export const primary = {
  0: "#000000",
  10: "#5A3815",
  20: "#794B1C",
  30: "#995F23",
  40: "#B8722A",
  50: "#C48A4E",
  60: "#D0A272",
  70: "#DCBA97",
  80: "#E8D2BB",
  90: "#F4EADF",
  95: "#FBF8F4",
  99: "#FEFEFD",
  100: "#FFFFFF"
};

export const secondary = {
  0: "#000000",
  10: "#111720",
  20: "#161E2C",
  30: "#1C2637",
  40: "#222E42",
  50: "#485262",
  60: "#6D7582",
  70: "#9399A2",
  80: "#B8BCC3",
  90: "#DEE0E3",
  95: "#F4F5F6",
  99: "#FDFDFD",
  100: "#FFFFFF"
};

export const tertiary = {
  0: "#000000",
  10: "#114B5B",
  20: "#16667A",
  30: "#1C809A",
  40: "#229AB9",
  50: "#48ABC5",
  60: "#6DBCD1",
  70: "#93CEDD",
  80: "#B8DFE9",
  90: "#D9ECF1",
  95: "#F4FAFC",
  99: "#FDFEFE",
  100: "#FFFFFF"
};

export const error = {
  0: "#000000",
  10: "#752D0D",
  20: "#9E3C12",
  30: "#C64C16",
  40: "#EF5B1B",
  50: "#F27742",
  60: "#F49369",
  70: "#F7AF8F",
  80: "#F8D1C0",
  90: "#FDE6DD",
  95: "#FEF7F4",
  99: "#FFFDFD",
  100: "#FFFFFF"
};

export const success = {
  0: "#000000",
  10: "#054131",
  20: "#075741",
  30: "#086E52",
  40: "#0A8463",
  50: "#34997E",
  60: "#5DAE98",
  70: "#87C3B3",
  80: "#B1D8CD",
  90: "#DAEDE8",
  95: "#F3F9F7",
  99: "#FDFEFD",
  100: "#FFFFFF"
};

export const neutral = {
  0: "#000000",
  10: "#302F2E",
  20: "#5F5E5B",
  30: "#7C7A77",
  40: "#989692",
  50: "#B5B2AD",
  60: "#D1CEC9",
  70: "#EEEAE4",
  80: "#F2EFEA",
  90: "#F6F4F1",
  95: "#FAF9F7",
  99: "#FEFEFE",
  100: "#FFFFFF"
};

export const neutral_variant = {
  0: "#000000",
  10: "#2E2D2C",
  20: "#5D5A57",
  30: "#797671",
  40: "#94918C",
  50: "#B0ACA6",
  60: "#CCC7C0",
  70: "#E8E2DA",
  80: "#EEE9E3",
  90: "#F3F0EC",
  95: "#F9F7F5",
  99: "#FEFEFE",
  100: "#FFFFFF"
};

export const muiColors = {
  button: {
    primary: "#222E42",
    primaryDark: "#161E2C",
    paper: "#FAF9F7",
    contrast: "#FDFDFD",
    border: "rgba(48, 47, 46, 0.23)",
    secondaryHover: "rgba(48, 47, 46, 0.04)",
    tertiaryHover: "rgba(34, 46, 66, 0.04)",
    disabled: "rgba(48, 47, 46, 0.12)"
  },
  text: {
    primary: "rgba(48, 47, 46, 0.95)",
    secondary: "rgba(48, 47, 46, 0.6)",
    disabled: "rgba(48, 47, 46, 0.4)",
    contrast: "#FDFDFD"
  },
  bg: {
    default: "#F6F4F1",
    contrast: "#FDFDFD"
  },
  primary: "#B8722A",
  paper: "#FAF9F7",
  error: "#EF5B1B",
  warning: "#66411B"
};
